import React from 'react'
import { inputModeType } from 'lib/util'
import {
  Body,
  FaqLink,
  Header,
  RadioField,
  RadioGroup,
  RadioLabel,
  RegIcon,
  SendNotificationWrapper,
} from './component.styles'
import {
  FAQ_LINK_URL,
  FAQ_LINK,
  NOTIFY_ADMINS_TEXT_BODY,
  NOTIFY_ADMINS_TEXT_HEADER,
  NOTIFY_RADIO_LABEL_FALSE,
  NOTIFY_RADIO_LABEL_TRUE,
  NOTIFY_USERS_TEXT_BODY,
  NOTIFY_USERS_TEXT_HEADER,
  SECOND_STEP_TEXT,
} from './constants'
import { FormValues } from '../Form/types'

interface AddUserModalSendNotificationProps {
  inputMode: string
  values: FormValues
}

const AddUserModalSendNotification: React.FC<
  AddUserModalSendNotificationProps
> = ({ inputMode, values }) => {
  const { selectedRole, sendNotification } = values
  const isAdmin = inputMode === inputModeType.single && selectedRole === 'Admin'

  return (
    <SendNotificationWrapper>
      <Header>
        {isAdmin ? (
          <React.Fragment>
            <span>{SECOND_STEP_TEXT}</span>
            <RegIcon>&reg;</RegIcon> {NOTIFY_ADMINS_TEXT_HEADER}
          </React.Fragment>
        ) : (
          NOTIFY_USERS_TEXT_HEADER
        )}
      </Header>
      <Body>
        {isAdmin ? (
          <span>{NOTIFY_ADMINS_TEXT_BODY}</span>
        ) : (
          <span>{NOTIFY_USERS_TEXT_BODY}</span>
        )}
        {!isAdmin && (
          <FaqLink
            href={FAQ_LINK_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {FAQ_LINK}
          </FaqLink>
        )}
      </Body>
      {!isAdmin && (
        <RadioGroup>
          <RadioLabel>
            <RadioField
              checked={sendNotification === 'true'}
              data-testid="send-notification-true"
              name="sendNotification"
              type="radio"
              value="true"
            />
            {NOTIFY_RADIO_LABEL_TRUE}
          </RadioLabel>
          <RadioLabel>
            <RadioField
              checked={sendNotification === 'false'}
              data-testid="send-notification-false"
              name="sendNotification"
              type="radio"
              value="false"
            />
            {NOTIFY_RADIO_LABEL_FALSE}
          </RadioLabel>
        </RadioGroup>
      )}
    </SendNotificationWrapper>
  )
}

export default AddUserModalSendNotification
